'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ./~/_es-to-primitive@1.2.1@es-to-primitive/helpers/isPrimitive.js
// module id = 519
// module chunks = 128